import { _updateCartHTML } from './_updateCartHTML';
import { _updateItem } from '../../Shopify/functions/_updateItem';

export const _onUpdateItem = (lineItem = null, action = 'add') => {

	if (!lineItem) {
		return;
	}

	_updateItem(lineItem.key, action === 'remove' ? lineItem.quantity - 1 : lineItem.quantity + 1)
		.then(cart => {
			_updateCartHTML(cart)
		});
};
